export {BasicPhone} from './BasicPhone';



// WEBPACK FOOTER //
// ./src/themes/components/BasicPhone/index.js